/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";
import {
  getMultisigTypeDecoder,
  getMultisigTypeEncoder,
  type MultisigType,
  type MultisigTypeArgs,
} from ".";

export type MultisigCreatedEvent = {
  multisigId: bigint;
  multisigType: MultisigType;
  owner: Address;
  threshold: number;
  signerCount: number;
  timestamp: bigint;
};

export type MultisigCreatedEventArgs = {
  multisigId: number | bigint;
  multisigType: MultisigTypeArgs;
  owner: Address;
  threshold: number;
  signerCount: number;
  timestamp: number | bigint;
};

export function getMultisigCreatedEventEncoder(): FixedSizeEncoder<MultisigCreatedEventArgs> {
  return getStructEncoder([
    ["multisigId", getU64Encoder()],
    ["multisigType", getMultisigTypeEncoder()],
    ["owner", getAddressEncoder()],
    ["threshold", getU8Encoder()],
    ["signerCount", getU8Encoder()],
    ["timestamp", getI64Encoder()],
  ]);
}

export function getMultisigCreatedEventDecoder(): FixedSizeDecoder<MultisigCreatedEvent> {
  return getStructDecoder([
    ["multisigId", getU64Decoder()],
    ["multisigType", getMultisigTypeDecoder()],
    ["owner", getAddressDecoder()],
    ["threshold", getU8Decoder()],
    ["signerCount", getU8Decoder()],
    ["timestamp", getI64Decoder()],
  ]);
}

export function getMultisigCreatedEventCodec(): FixedSizeCodec<
  MultisigCreatedEventArgs,
  MultisigCreatedEvent
> {
  return combineCodec(
    getMultisigCreatedEventEncoder(),
    getMultisigCreatedEventDecoder(),
  );
}
